"use strict";

const utils = require("js/util.js");

/**
 * We need following classes to work properly:
 * - reorder-element: the elements which can be moved
 * - reorder-element-parent: the parent of all the above  elements
 */
/**
 * This is specific for tabs!
 */
const COLLAPSED_BTN = "#tab-collapse-button";

function findTab(node, draggedTab) {
    // this is the case if we drag into a different tabpane (i.e. from the right search into the left search)
    if (draggedTab == null) {
        return null;
    } else if (node.matches(COLLAPSED_BTN)) {
        return null;
    } else {
        const tab = utils.findParentWithSelector(node, ".reorder-element", { stop: [".reorder-element-parent"] });

        // here we need to check if the draggedTab is in the same tab-row, in case someone trys to drag the tab
        // into a different tab-row
        if (tab != null && utils.siblingsContain(tab, draggedTab)) {
            return tab;
        } else {
            return null;
        }
    }
}

module.exports.findTab = findTab;

module.exports.addDragAndDrop = function (tabPane, onTabDropFunction) {
    let draggedTab = null;
    let insertBefore = null;
    let placeholder = null;
    let tabPaneBounding = tabPane.getBoundingClientRect();

    tabPane.addEventListener("dragstart", (e) => {
        e.dataTransfer.effectAllowed = "move";
        draggedTab = e.target;
    });

    tabPane.addEventListener("dragover", (e) => {
        // prevent default to allow drop
        e.preventDefault();
    });

    tabPane.addEventListener("dragenter", (e) => {
        const tabOver = findTab(e.target, draggedTab);

        if (tabOver != null) {
            insertBefore = tabOver;

            if (placeholder != null) {
                placeholder.style.marginLeft = null;
            }
            placeholder = insertBefore;

            if (insertBefore.dataset.id != draggedTab.dataset.id) {
                insertBefore.style.marginLeft = draggedTab.offsetWidth + "px";
            }
        }
    });

    tabPane.addEventListener("dragleave", (e) => {
        const tabOver = findTab(e.target, draggedTab);
        if (tabOver != null) {
            // required for detecting that we are leaving the last tab to the right
            let boundingClientRect = tabOver.getBoundingClientRect();
            if (e.clientX > boundingClientRect.x && tabOver.nextElementSibling == null) {
                tabOver.style.marginLeft = null;
                insertBefore = null;
            }
        }

        let insideX = tabPaneBounding.left < e.clientX && e.clientX < tabPaneBounding.right;
        let insideY = tabPaneBounding.top < e.clientY && e.clientY < tabPaneBounding.bottom;
        if (!insideX || !insideY) {
            // in case we dragged outside the parent
            if (placeholder != null) {
                placeholder.style.marginLeft = null;
            }
        }
    });

    tabPane.addEventListener("drop", (e) => {
        if (draggedTab != null) {
            const insertBeforeId = insertBefore == null ? "append" : insertBefore.dataset.id;
            onTabDropFunction(draggedTab.dataset.id, insertBeforeId);

            placeholder.style.marginLeft = null;

            draggedTab = null;
            insertBefore = null;
            placeholder = null;
        }
    });
};
